var map = {
	"./baohuang.png": 499,
	"./buyu.png": 983,
	"./doudizhu.png": 405,
	"./gouji.png": 74,
	"./huawendi.jpg": 544,
	"./jiwan.png": 172,
	"./majiang.png": 966,
	"./xiaodi.png": 363,
	"./zhendi.png": 757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 869;